import { render, staticRenderFns } from "./courseEditorTest.vue?vue&type=template&id=056fb1e2&scoped=true&"
import script from "./courseEditorTest.vue?vue&type=script&lang=js&"
export * from "./courseEditorTest.vue?vue&type=script&lang=js&"
import style0 from "./courseEditorTest.vue?vue&type=style&index=0&id=056fb1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fb1e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VExpandTransition,VIcon,VMenu,VSheet})
